/* eslint-disable multiline-ternary */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import Header from 'src/components/header/Header';
import {
  incrementNewsFeedPage
} from 'src/store/socialMedia/socialMedia.slice';
import { Button, ConditionalComponent, ConfirmModal, InfiniteScroll, Loader } from 'src/components/common';
import { useGetIdentity } from 'src/hooks';
import {
  CompanyCard,
  InviteNetwork
} from 'src/components/cards';
import IncubatorsCard from 'src/components/IncubatorsCard/IncubatorsCard';
import CreateCompanyNowCard from 'src/components/CreateCompanyNowCard/CreateCompanyNowCard';
import DiscoverCardTop from 'src/components/discover/discoverCardTop/discoverCardTop';
import DicoverProgramCard from 'src/components/discover/dicoverProgramCard/dicoverProgramCard';
import { MdAdd } from 'react-icons/md';
import CreateProgramListForm from 'src/components/discover/createProgramForm/CreateProgramListForm';
import { changeFilterModalState, incrementListProgramsPage, programListList, resetListProgram } from 'src/store/program/program.slice';
import { useNavigate } from 'react-router-dom';
import ListingModal from 'src/components/common/ListingModal/ListingModal';
import { TSelectCardRadioButton } from 'src/components/common/formFields/selectCardRadio/SelectCardRadio';
import { Industries } from 'src/constants/user.constants';
import { enumToJson } from 'src/utils';
import { FaAngleDown } from 'react-icons/fa6';

export type TfilterProps = { endDate: string, programType: string[], industry: string[] }
const Discover = () => {
  const { filterModal, programsListPageNumber, moreListProgramsLeft, programsListPerPage, listPrograms, programLoading } = useAppSelector(
    (store) => store.program
  );

  // Hooks
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const { getIdentities } = useGetIdentity();
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);

  // ref 
  const endDateRef: React.MutableRefObject<any> = useRef(null);

  // state
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [filter, setFilter] = useState<TfilterProps>({ endDate: '', programType: [], industry: [] })

  const programType = useMemo(() => {
    return [
      { label: 'Govt. Programs', value: 'Govt. Programs', id: 'Govt. Programs' },
      { label: 'Corporate Programs', value: 'Corporate Programs', id: 'Corporate Programs' },
      { label: 'Incubators', value: 'Incubators', id: 'Incubators' },
      { label: 'E-Cells', value: 'E-Cells', id: 'E-Cells' }
    ]
  }, [])
  const industriesOptions = useMemo(() => {
    return enumToJson({
      enumData: Industries
    })
  }, [Industries])

  const { loggedInCompanyId, loggedInUserType } = getIdentities();
  function handleAction(type: string, filterType: string) {
    const value = type === 'clear-all' ? [] : filterType === 'programType' ? programType.map((item) => item.label) : industriesOptions?.map((item) => item.label)
    setFilter({ ...filter, [filterType]: value })
  }

  function handleSelect(value: string, type, checked: boolean) {
    if (type) {
      const valuesArr = checked ? [...filter[type], value] : filter[type]?.filter((item: string) => item !== value);
      setFilter({ ...filter, [type]: valuesArr })
    }
  }
  const fetchListProgram = ({ reload = false }: { reload?: boolean }) => {
    if (reload) {
      dispatch(resetListProgram());
    }
    const payload = {
      limit: programsListPerPage,
      offset: programsListPageNumber,
      ...(filter.programType?.length > 0 && filter.programType.length !== programType.length ? { programType: filter.programType?.join(',') } : {}),
      ...(filter.industry?.length > 0 && filter.industry?.length !== industriesOptions?.length ? { industry: filter.industry?.join(',') } : {}),
      ...(filter.endDate ? { endDate: filter.endDate } : {})
    }
    dispatch(programListList(payload))
  };

  const loadMoreItems = () => {
    if (moreListProgramsLeft && !programLoading) {
      dispatch(incrementListProgramsPage(1));
    }
  };
  function handleClose() {
    fetchListProgram({ reload: false });
    setIsModalOpen(false)
  }
  function handleNavigate() {
    navigate('/login?prev=/discover')
  }
  function handleDateFilter(e) {
    setFilter({ ...filter, endDate: e.target.value })
  }
  function handleListModal(type) {
    const data = type === filterModal.state ? [] : type === 'programType' ? programType : industriesOptions
    dispatch(changeFilterModalState({ state: type === filterModal.state ? '' : type, data }))
  }

  // useEffect(() => {
  //   fetchListProgram({ reload: false });
  // }, [isAuthorized]);

  useEffect(() => {
    if (!programLoading) {
      fetchListProgram({ reload: false });
    }
  }, [programsListPageNumber, filter]);

  useEffect(() => {
    const industry = industriesOptions?.map((item) => item.label)
    const programTypeData = programType?.map((item) => item.label)
    setFilter({ ...filter, industry, programType: programTypeData })
  }, [])
  return (
    <>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
      {/* <CreateProgramModal onModalClose={onModalClose} isModalOpen={isModalOpen} /> */}
      <InfiniteScroll
        className="dashboard"
        onScrollEnd={loadMoreItems}
        loading={programLoading}
        showLoader={false}
        showFooter={false}
        moreItemsLeft={moreListProgramsLeft}
      >
        <Header />
        <div className="dashboard__body dashboard__newBody">
          <div className="dashboard__body__feed">
            <DiscoverCardTop />
            <div className="dashboard__body__feed__actions">
              {<div className='dashboard__body__feed__actions__filters' style={{ opacity: isModalOpen ? '0' : '1' }}>
                <p className='dashboard__body__feed__actions__filters__filterHeader'>Filters:</p>
                <div className='dashboard__body__feed__actions__filters__date-field'>
                  <input type="date" id="endDate" onChange={handleDateFilter} ref={endDateRef} className='dashboard__body__feed__actions__filters__date-field__input' />
                  <Button variant={filter.endDate ? "primary" : "secondary"} size="extraSmall" onClick={() => !filter.endDate ? endDateRef.current?.showPicker() : setFilter({ ...filter, endDate: '' })}>End Date <FaAngleDown /></Button>
                </div>

                <div className='dashboard__body__feed__actions__filters__date-field'>
                  <Button variant={filter.programType.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('programType')}>Program Type <FaAngleDown /></Button>
                  {filterModal.state && filterModal.state === 'programType' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                </div>
                <div className='dashboard__body__feed__actions__filters__date-field'>
                  <Button variant={filter.industry.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('industry')}>Industry <FaAngleDown /></Button>
                  {filterModal.state && filterModal.state === 'industry' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                </div>

              </div>}
              <div className="dashboard__body__feed__actions__add-button-container">
                <Button variant="secondary" size="extraSmall" onClick={() => {
                  if (isAuthorized) {
                    setIsModalOpen((prev: boolean) => !prev)
                  } else {
                    setShow(true)
                  }
                }}>
                  {isModalOpen ? (
                    "Back to List"
                  ) : (
                    <>
                      <MdAdd />List A Program
                    </>
                  )}
                </Button>
              </div>
            </div>
            {isModalOpen ? (
              <CreateProgramListForm handleClose={handleClose} />
            ) : (
              <DicoverProgramCard listPrograms={listPrograms} />
            )}
            {programLoading && <Loader />}
            {!programLoading && moreListProgramsLeft && (
              <Button
                className="infinite-scroll-component__footer"
                variant="tertiary"
                size="extraSmall"
                onClick={loadMoreItems}
              >
                {moreListProgramsLeft ? 'Load more items' : <>&bull;</>}
              </Button>
            )}

          </div>
          <div className="dashboard__cards">

            <InviteNetwork />
            {loggedInUserType === 'User' && (
              <ConditionalComponent
                condition={Boolean(loggedInCompanyId)}
                whenTrue={<CompanyCard selfCompany={true} companyId={loggedInCompanyId} />}
                whenFalse={<CreateCompanyNowCard />}
              />
            )}

            <IncubatorsCard />
          </div>
        </div>
      </InfiniteScroll>
    </>
  );
};

export default Discover;
